import { TableRow } from '@mui/material';
import { styled } from '@mui/material/styles';

export const PmiTableRow = styled(TableRow)(() => ({
  // '&:nth-of-type(odd)': {
  //   backgroundColor: 'rgba(0, 0, 0, 0.09)',
  // },
  backgroundColor: 'white',
  '&:hover': {
    background:
      'linear-gradient(-45deg, #e7e6e6 0%, #fafafa 15%, #e0dfdf 15%, #fff 35%, #eeebeb 85%,#dad8d8 100%)',
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));
